<template>
  <div class="actions-panel">
    <span v-if="hint" class="hint">
      {{ hint }}
    </span>

    <div class="border-buttons">
      <div class="border-button">
        <vbutton
          v-if="!hasInvitesRoleRead"
          :class="{'not-active': is_admin && isInvitesSelected && (userIsCompanyAdmin || userIsCompany)}"
          :icon="'icon_letter'"
          :color="'transparent'"
          :text_color="'grey'"
          :label="isInvitesSelected ? 'responses.actions.sendMail' : ''"
          :type="isInvitesSelected ? '' : 'icon'"
          @click="sendMessage"
          v-tooltip.top-center="$tr('common.iconTooltips.mailSelectedCandidates')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCookie } from 'tiny-cookie';

export default {
  name: 'invites-actions',

  props: {
    pendingSpinner: Boolean,
    handleExportInvites: Function,
    noInvites: Boolean,
    hasInvitesRoleRead: {
      type: Boolean,
      default: false
    },
    changeSendMessageDisplay: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters('company_new', ['isRatesExpired']),

    hint () {
      const count = this.selectedInvites.length

      if (!count) {
        return ''
      }

      const start = this.$tr('common.selectedInvites', count, {
        is_pluralization: true
      })
      return `${start}: ${count}`
    },

    creationRoute () {
      return {
        name: 'invites-creation'
      }
    },

    selectedInvites () {
      return this.$store.getters['invites/selectedList'] || []
    },

    isInvitesSelected () {
      return this.selectedInvites.length > 0
    },

    userIsCompanyAdmin () {
      return this.$store.getters['user/isCompanyAdmin']
    },

    userIsCompany () {
      return this.$store.getters['user/isCompanyUser']
    },

    is_admin() {
      const localStorage_admin_token = window.localStorage.admin_token;
      const cookie_admin_token = getCookie('admin_token') ? JSON.parse(getCookie('admin_token')) : null;;
      if (localStorage_admin_token || cookie_admin_token) {
        return true
      } else {
        return false
      }
    },

    invite_tooltip_options() {
      if (!this.isRatesExpired) {
        return {};
      }

      return {
        content: this.$tr('rates.expired.tooltip'),
        trigger: 'hover',
        placement: 'top-center'
      }
    }
  },

  methods: {
    go_to_creation_route() {
      this.$router.push(this.creationRoute);
    },

    sendMessage() {
      if (this.isInvitesSelected) {
        this.changeSendMessageDisplay();
      } else {
        this.$noty.error(this.$tr('common.iconTooltips.notSelectedCandidate'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/queries.scss';

  $gray-bg: #f1f2f2;
  $gray-text: #555;

  .hint {
    margin-right: 20px;
  }

  .standart-navigation .actions .actions-panel {
    margin-left: 0;
  }

  .border-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .border-button {
      position: relative;
      padding-right: 1px;

      &:before {
        content: '';
        position: absolute;
        width: 1px;
        height: 30px;
        top: 5px;
        bottom: 5px;
        left: -1px;
        background: #D3D6DA;
      }

      &:hover:not(.disabled) {
        &:before {
          display: none;
        }

        & + .border-button:before {
          display: none;
        }
      }

      &:first-child {
        &:before {
          display: none;
        }
      }
    }
  }

  .tooltip-wrapper {
    margin-left: 15px;
  }
</style>
